import React, { useState } from 'react';
import BetSectionTabsNames from './betSectionTabsNames';
import BetInput from './betInput';
import AdditionalButtons from './additionalButtons';
import AutoCashOut from './autoCashOut';
import AutoBet from './autoBet';
import BetButton from './betButton';
import Markets from './markets';
import BetInputForMarkets from './betInputForMarkets';
import { betSectionTabsName } from '../../../enums';
import BetButtonForMarkets from './betButtonForMarkets';

const BetSection = ({
  t,
  isDemo,
  onBlur,
  limits,
  isStart,
  betData,
  balance,
  onChange,
  betAmount,
  numPadData,
  doBetSender,
  autoBetData,
  minBetAmount,
  isAutoCashOut,
  activeTabName,
  isBetAccepted,
  activeFreeBet,
  resetDoBetData,
  autoCashOutOdd,
  handleTabChange,
  changeBetAmount,
  showNotification,
  handleOpenNumPad,
  handleChangeAutoBet,
  handleChangeInputValue,
  isDisabledBetSection,
  isOpenedNumPadOpened,
  handleSubmitNumPadData,
  handleSwitchAutoCashOut,
  isDisabledMarketSection,
  updateIsDisabledBetSection,
  handleChangeAutoCashOutInput,
  handleChangeAutoCashOutInputValue,
  isAutoBetConfigEnabled,
}) => {
  const [isValidatedAmountForMarkets, setIsValidatedAmountForMarkets] = useState(false);
  const [isValidatedAmountForManual, setIsValidatedAmountForManual] = useState(false);
  const [isValidatedAutoCashOutOdd, setIsValidatedAutoCashOutOdd] = useState(false);
  const { markets } = betSectionTabsName;
  const isMarketSection = activeTabName === markets;

  const decidedCallBackCall = (callback, isManualSection = false, isAutoCashOutInput = false) => {
    // TODO add this functionality for bet button and manual bet section
    const condition = isManualSection ? isValidatedAmountForManual : isValidatedAmountForMarkets;
    if ((isAutoCashOutInput && isValidatedAutoCashOutOdd) || condition) {
      if (isAutoCashOutInput) {
        setIsValidatedAutoCashOutOdd(false);
      } else {
        isManualSection
          ? setIsValidatedAmountForManual(false)
          : setIsValidatedAmountForMarkets(false);
      }
    } else {
      callback();
    }
  };

  return (
    <div className='oddball-bet-section'>
      <BetSectionTabsNames activeTabName={activeTabName} handleTabChange={handleTabChange} t={t} />
      <div className={`oddball-game-bet-section-wrp`}>
        {activeTabName === markets ? (
          <div
            className={`odd-g-coef-wrapper ${
              isMarketSection && isDisabledMarketSection ? 'passive' : ''
            }`}
          >
            <Markets />
          </div>
        ) : (
          <div className='odd-g-inp-sm-btn-wrp'>
            <div className='odd-g-inp-sm-btn-content'>
              <BetInput
                onBlur={onBlur}
                limits={limits}
                onChange={onChange}
                betAmount={betAmount}
                numPadData={numPadData}
                autoCashOutOdd={autoCashOutOdd}
                isAutoCashOut={isAutoCashOut}
                activeFreeBet={activeFreeBet}
                minBetAmount={minBetAmount}
                changeBetAmount={changeBetAmount}
                showNotification={showNotification}
                handleOpenNumPad={handleOpenNumPad}
                decidedCallBackCall={decidedCallBackCall}
                isOpenedNumPadOpened={isOpenedNumPadOpened}
                isDisabledBetSection={isDisabledBetSection}
                handleChangeInputValue={handleChangeInputValue}
                handleSubmitNumPadData={handleSubmitNumPadData}
                setIsValidatedAmountForManual={setIsValidatedAmountForManual}
              />
              <AdditionalButtons
                t={t}
                limits={limits}
                balance={balance}
                betAmount={betAmount}
                activeFreeBet={activeFreeBet}
                resetDoBetData={resetDoBetData}
                changeBetAmount={changeBetAmount}
                handleChangeInputValue={handleChangeInputValue}
                isDisabledBetSection={isDisabledBetSection}
                decidedCallBackCall={decidedCallBackCall}
              />
              <div className='checkbox-wrp'>
                <AutoCashOut
                  t={t}
                  maxWin={limits.maxWin}
                  isActive={isAutoCashOut}
                  betAmount={betAmount}
                  numPadData={numPadData}
                  activeFreeBet={activeFreeBet}
                  autoCashOutOdd={autoCashOutOdd}
                  handleOpenNumPad={handleOpenNumPad}
                  decidedCallBackCall={decidedCallBackCall}
                  isDisabledBetSection={isDisabledBetSection}
                  handleSwitchAutoCashOut={handleSwitchAutoCashOut}
                  isOpenedNumPadOpened={isOpenedNumPadOpened}
                  handleSubmitNumPadData={handleSubmitNumPadData}
                  isValidatedAutoCashOutOdd={isValidatedAutoCashOutOdd}
                  setIsValidatedAutoCashOutOdd={setIsValidatedAutoCashOutOdd}
                  handleChangeAutoCashOutInput={handleChangeAutoCashOutInput}
                  handleChangeAutoCashOutInputValue={handleChangeAutoCashOutInputValue}
                />
                {isAutoBetConfigEnabled && (
                  <AutoBet
                    t={t}
                    isDemo={isDemo}
                    isStart={isStart}
                    betData={betData}
                    autoBetData={autoBetData}
                    handleChangeAutoBet={handleChangeAutoBet}
                    doBetSender={doBetSender}
                    isDisabledBetSection={isDisabledBetSection}
                    updateIsDisabledBetSection={updateIsDisabledBetSection}
                    isBetAccepted={isBetAccepted}
                  />
                )}
              </div>
            </div>
          </div>
        )}
        <div className='bet-btn-wrp'>
          {isMarketSection && (
            <BetInputForMarkets
              handleOpenNumPad={handleOpenNumPad}
              isMarketSection={isMarketSection}
              decidedCallBackCall={decidedCallBackCall}
              handleChangeInputValue={handleChangeInputValue}
              setIsValidatedAmount={setIsValidatedAmountForMarkets}
            />
          )}
          <div className='buttons-case'>
            {isMarketSection ? (
              <BetButtonForMarkets decidedCallBackCall={decidedCallBackCall} />
            ) : (
              <BetButton decidedCallBackCall={decidedCallBackCall} />
            )}
            {/* <button className='re-bet-button'> */}
            {/*  <span className='bet-section-btn-title'>REBET</span> */}
            {/* </button> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BetSection;
